'use strict';

var Avatar = require('./src/Avatar.js');
var Button = require('./src/Button.js');
var Paragraph = require('./src/Paragraph.js');
var Skeleton$1 = require('./src/Skeleton.js');

const Skeleton = Skeleton$1.Skeleton;
Skeleton.Avatar = Avatar.Avatar;
Skeleton.Button = Button.Button;
Skeleton.Paragraph = Paragraph.Paragraph;

exports.Skeleton = Skeleton;
//# sourceMappingURL=index.js.map
